/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type TourReactivationPageMutationVariables = {
    tourId: string;
};
export type TourReactivationPageMutationResponse = {
    readonly tourReactivate: {
        readonly tour: {
            readonly id: string;
            readonly title: string;
        };
    };
};
export type TourReactivationPageMutation = {
    readonly response: TourReactivationPageMutationResponse;
    readonly variables: TourReactivationPageMutationVariables;
};



/*
mutation TourReactivationPageMutation(
  $tourId: String!
) {
  tourReactivate(input: {id: $tourId}) {
    tour {
      id
      title
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tourId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "tourId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "TourReactivatePayload",
    "kind": "LinkedField",
    "name": "tourReactivate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Tour",
        "kind": "LinkedField",
        "name": "tour",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TourReactivationPageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TourReactivationPageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "288d9ae2491f5360a90640ab3d6e013d",
    "id": null,
    "metadata": {},
    "name": "TourReactivationPageMutation",
    "operationKind": "mutation",
    "text": "mutation TourReactivationPageMutation(\n  $tourId: String!\n) {\n  tourReactivate(input: {id: $tourId}) {\n    tour {\n      id\n      title\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '4dc95b493a4f220757afe6bbc184d876';
export default node;
